const formatPeriodo = (value) => {
  if (value == null) return '-';
  const s = String(value).trim();
  const m = /^(\d{4})(0[1-9]|1[0-2])$/.exec(s);
  return m ? `${m[2]}/${m[1]}` : s; 
};
const today = new Date();
const day = String(today.getDate()).padStart(2, '0');
const month = String(today.getMonth() + 1).padStart(2, '0');
const year = today.getFullYear();
const diaconsulta = `${day}/${month}/${year}`
import React, {forwardRef } from 'react';


const RegistroCard = forwardRef(({registro},ref) =>{

  return (
    <div className="col-xs-12" tabIndex={-1} ref={ref}>
      <div className="row p-a-2 panel panel-default">
          <div class="col-xs-12">
              <h3>
                <span class="text-primary h4">
                  <i class="fa fa-calendar"></i>&nbsp;Consulta realizada el {diaconsulta}
                </span>
              </h3> 
              <hr class="m-y-2" />
          </div>
          <p className="col-xs-12 col-md-6">
            CUIT:
            <br />
            <strong>{registro[0].cuit}</strong>
          </p>

          <p className="col-xs-12 col-md-6">
            Apellido y Nombre o Razón Social:
            <br />
            <strong>{registro[0].descripcion}</strong>
          </p>

          <p className="col-xs-12 col-md-6">
            Empadronamiento REAR/RECE/RCEL:
            <br />
            <strong>{registro[0].leyenda}</strong>
          </p>

          <p className="col-xs-12 col-md-6">
            Fecha de Empadronamiento:
            <br />
            <strong>{registro[0].fechaEmpadronado}</strong>
          </p>

          <p className="col-xs-12 col-md-6 m-b-0">
            Período de inicio autorizado:
            <br />
            <strong>{formatPeriodo(registro?.[0]?.periodo)}</strong>
          </p>
      </div>      
    </div>
  );
});

export default RegistroCard;
